import AppForm from "../app-components/Form/AppForm";

Vue.component("mymcd-form", {
    mixins: [AppForm],
    props: {

    },
    data: function() {
        return {
            form: {
                mymcd_sync: true
            },
        };
    },

    methods: {
        getData: function()
        {
            return this.form;
        }
    },
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/employee/EmployeeMymcdForm.js